import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { App } from './App';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SmartFeedbackProvider } from './contexts/SmartFeedbackContext';
import { ToastProvider } from './contexts/ToastContext';
import { mainRoutes } from './routes/mainRoutes';
import { protectedRoutes } from './routes/protectedRoutes';
const GlobalModals = lazy(() => import('./components/GlobalModals').then(module => ({
  default: module.GlobalModals
})));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then(module => ({
  default: module.NotFoundPage
})));
const StaticHtmlPage = lazy(() => import('./pages/StaticHtmlPage').then(module => ({
  default: module.StaticHtmlPage
})));
const PUBLIC_PREFIXES = ['/about', '/blog', '/faq', '/privacy', '/terms', '/es', '/fr', '/de', '/pt', '/ja', '/ko', '/hi', '/id'];
function CatchAllRoute() {
  const location = useLocation();
  const isPublic = PUBLIC_PREFIXES.some(prefix => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`));
  return isPublic ? <StaticHtmlPage data-id="element-65" /> : <NotFoundPage data-id="element-66" />;
}
function PageLoader() {
  return <div className="flex min-h-screen items-center justify-center bg-[#050505]" data-id="element-67">
      <div className="flex flex-col items-center gap-4" data-id="element-68">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-red-500 border-t-transparent" data-id="element-69" />
        <span className="font-mono text-sm tracking-wider text-gray-400" data-id="element-70">
          LOADING...
        </span>
      </div>
    </div>;
}
const ONBOARDING_EXEMPT_PREFIXES = ['/onboarding', '/auth', '/login', '/signup', '/payment', '/loading', '/results', '/about', '/privacy', '/terms', '/faq', '/blog', '/test-google', '/debug', '/es', '/fr', '/de', '/pt', '/ja', '/ko', '/hi', '/id'];
function OnboardingRedirectGuard() {
  const {
    user,
    loading
  } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading || !user) return;
    const completed = (user.user_metadata as {
      completedOnboarding?: boolean;
    }).completedOnboarding;
    if (completed) return;
    const isExempt = ONBOARDING_EXEMPT_PREFIXES.some(prefix => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`));
    if (!isExempt) {
      navigate('/onboarding', {
        replace: true
      });
    }
  }, [loading, location.pathname, navigate, user]);
  return null;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-71">
      <AuthProvider data-id="element-72">
        <ToastProvider data-id="element-73">
          <SmartFeedbackProvider data-id="element-74">
            <OnboardingRedirectGuard data-id="element-75" />
            <Suspense fallback={null} data-id="element-76">
              <GlobalModals data-id="element-77" />
            </Suspense>
            <Suspense fallback={<PageLoader data-id="element-79" />} data-id="element-78">
              <Routes data-id="element-80">
                <Route path="/" element={<App data-id="element-82" />} data-id="element-81" />
                {mainRoutes}
                {protectedRoutes}
                <Route path="*" element={<CatchAllRoute data-id="element-84" />} data-id="element-83" />
              </Routes>
            </Suspense>
          </SmartFeedbackProvider>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>;
}